import React, { useEffect, useState } from "react";
import avatarPlaceholder from "../../../../assets/placeholder/avatar_placeholder.png";
import ToggleSwitch from "../../ToggleSwitch";
import CardMenu from "../../CourseComponents/CardMenu/index";
import "./examComponent.scss";
import { generatePath, RouteComponentProps, withRouter } from "react-router";
import * as appRoutes from "../../../../routes/routeConstants/appRoutes";
import ExamForm from "../ExamForm";
import { ExamService } from "../../../../services/ExamService/exam.service";
import DeleteAlert from "../../DeleteAlert";
interface CardProps extends RouteComponentProps {
  exams: any[];
  refreshList: Function;
  currentPageNumber: number;
}
const ExamComponent = (props: CardProps) => {
  useEffect(() => {
    setExamsData(exams);
  }, [props.exams]);

  console.log(props.exams);
  const { exams, refreshList, currentPageNumber } = props;
  const [examsData, setExamsData] = useState<any>([]);
  const [formVisible, setFormVisibility] = useState(false);
  const [currentExam, setCurrentExam] = useState<any>();
  const [deleteVisible, setDeleteVisible] = useState(false);
  const handleDelete = () => {
    ExamService.deleteExam(
      {
        id: currentExam?.id,
      },
      (response: any) => {
        setDeleteVisible(false);
        refreshList(currentPageNumber);
        setExamsData([
          ...examsData.filter((data: any) => data.id !== currentExam?.id),
        ]);
      },
      (error: any) => {}
    );
  };
  const handleStatusToggle = (examId: number, checked: boolean) => {
    const jsonData = { isActive: checked };

    ExamService.updateExam(
      {
        id: examId,
        exam: jsonData,
      },
      (response: any) => {
        refreshList(currentPageNumber);
      },
      (error: any) => {}
    );
  };
  return (
    <div>
      <ExamForm
        title="Edit Exam"
        visible={formVisible}
        setVisible={setFormVisibility}
        data={currentExam}
        refreshList={refreshList}
        currentPageNumber={currentPageNumber}
      />
      <DeleteAlert
        title={currentExam?.acronym}
        logo={currentExam?.displayPictureUrl}
        detail={currentExam?.name}
        visible={deleteVisible}
        setVisible={setDeleteVisible}
        deleteText="exam"
        deleteWarning="This exam will be deleted permanently"
        handleDelete={handleDelete}
      />
      <div className="exams">
        {examsData.map((value: any, index: number) => {
          return (
            <div className="exam-card">
              <div className="exam-card__body">
                <div className="exam-card-left__wrapper">
                  <img src={value.displayPictureUrl || avatarPlaceholder} />
                  <div className="exam-card__content">
                    <div className="exam-card__acronym">{value.acronym}</div>
                    <div className="exam-card__name">
                      {value.name}
                      <span className="details-separator" />
                      <span className="exam-card__amount">
                        {value.amountRupees || (
                            <span>&#8377;{value.amountPaise}</span>
                          ) || <span>&#8377;{value.amount}</span>}
                      </span>
                    </div>
                    <div>ID: {value.id}</div>
                  </div>
                </div>
                <div className="exam-card-right__wrapper">
                  <div className="exam-card__toggle">
                    <ToggleSwitch
                      checked={value.isActive}
                      handleChange={(checked) =>
                        handleStatusToggle(value.id, checked)
                      }
                    />
                  </div>
                  <div
                    className="exam-card__menu"
                    onClick={() => {
                      setCurrentExam(
                        exams.filter((data) => data.id == value.id)[0]
                      );
                    }}
                  >
                    <CardMenu
                      menuText="Exam"
                      handleEdit={() => setFormVisibility(true)}
                      handleDelete={() => setDeleteVisible(true)}
                    />
                  </div>
                </div>
              </div>
              <div className="exam-card__footer">
                <div
                  onClick={() => {
                    props.history.push(
                      generatePath(appRoutes.EXAM_SUBJECTS, {
                        examId: value.id,
                        examName: value.acronym,
                      })
                    );
                  }}
                >
                  Subject
                </div>
                <div>Schedule</div>
                <div
                  onClick={() => {
                    props.history.push(
                      generatePath(appRoutes.PREVIOUS_PAPER, {
                        examId: value.id,
                        examName: value.acronym,
                      })
                    );
                  }}
                >
                  Previous paper
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default withRouter(ExamComponent);
